import * as types from "../../../types/Milestones";

import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";
import CheckCircleBlue from "../../../images/check-circle-blue.svg";

var styles = {
  // GENERAL:
  milestoneWrapper: function milestoneWrapper(props) {return {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      '&:last-of-type': {
        '&::after': {
          display: 'none'
        }
      },
      '&::after': {
        content: '""',
        display: 'block',
        backgroundColor:
        props.status === types.MilestoneStatuses.COMPLETED ? colors.blue[600] : colors.neutral[900],
        position: 'absolute'
      }
    };},
  milestoneItem: {
    minWidth: '2.6rem',
    minHeight: '2.6rem',
    borderWidth: '0.4rem',
    borderStyle: 'solid',
    borderRadius: '50%',
    boxSizing: 'border-box'
  },
  milestoneItemInactive: {
    borderColor: colors.neutral[900]
  },
  milestoneItemActive: {
    borderColor: colors.blue[600]
  },
  milestoneItemCompleted: function milestoneItemCompleted(props) {return {
      borderColor: colors.blue[600],
      border: 'none',
      backgroundImage:
      props.status === types.MilestoneStatuses.COMPLETED && "url(".concat(CheckCircleBlue, ")"),
      backgroundSize: 'cover'
    };},
  milestoneLabel: function milestoneLabel(props) {return {
      display: 'block',
      color: props.status === types.MilestoneStatuses.ACTIVE ? colors.blue[600] : colors.neutral[900],
      font: {
        size: '1.6rem',
        weight: 700,
        lineHeight: '2.4rem'
      },
      letterSpacing: '0.02rem'
    };},

  // VERTICAL:

  milestoneWrapperVisualTypeVertical: function milestoneWrapperVisualTypeVertical(props) {return {
      '&::after': {
        height: props.connectingLineWidth || '6.8rem',
        width: '0.3rem',
        // A half of the circle height - a half of the width of the connecting line.
        left: '1.15rem',
        // The height of the circle (2.6rem) + a half of the gap between the circles and the lines (0.8rem).
        top: '3.4rem'
      }
    };},
  milestoneItemVisualTypeVertical: function milestoneItemVisualTypeVertical(props) {return {
      // 1.6rem - is a gap between the circles and the lines.
      marginBottom: "calc(".concat(props.connectingLineWidth, " + 1.6rem )")
    };},
  milestoneLabelVisualTypeVertical: {
    position: 'absolute',
    // The circle's size + a left gap.
    left: '3.6rem',
    top: 0,
    bottom: 0,
    right: 0
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map